module.exports = __webpack_public_path__ + "img/logo_sun_n.d01de53c.png";